var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChinese(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_44939_319320)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_44939_319320)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.5-.5H-1v33h49.5v-33z",
    fill: "#EE1C25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.315 5.994l2.91 8.954-7.618-5.534h9.415l-7.617 5.534 2.91-8.954zM16.21 4.475l-.275 3.126-1.615-2.69 2.888 1.227-3.058.704 2.06-2.367zM20.05 8.145l-1.468 2.774-.444-3.107 2.185 2.253-3.091-.538 2.817-1.382zM20.414 13.678l-2.471 1.934.862-3.017 1.076 2.948-2.603-1.753 3.136-.112zM16.147 16L16 19.135l-1.725-2.622 2.937 1.107-3.027.83 1.96-2.45z",
    fill: "#FF0"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_44939_319320"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_44939_319320"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(-1 -.5)",
    d: "M0 0h49.5v33H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChinese);
export default __webpack_public_path__ + "static/media/chinese.2039f14a1aaa1a397a5e9f42357ef59d.svg";
export { ForwardRef as ReactComponent };